import { useMemo } from "react";

import ProgressBar from "@/components/shared/ui/ProgressBar";
import { DEFAULT_ROUND_LENGTH_IN_DAYS } from "@/constants";
import { MethodologyWithRoundDetails } from "@/types/Methodology";
import { formatDistanceToNowStrict } from "date-fns";

interface IProps {
	methodologyDetails: MethodologyWithRoundDetails;
	customRoundLength?: number;
	hideDetailsIfRoundClosed?: boolean;
}

const FeedbackTimeline = (props: IProps) => {
	const methodologyDetails = props.methodologyDetails;
	const reviewEndDate = methodologyDetails.reviewEndDate;
	const totalTimeSpan = props.customRoundLength || DEFAULT_ROUND_LENGTH_IN_DAYS;
	const { days, hours, minutes, progress } = useMemo(() => {
		if (methodologyDetails?.methodologyRoundStatus === "RUNNING" && reviewEndDate) {
			{
				const distance = formatDistanceToNowStrict(new Date(reviewEndDate));
				const parts = distance.split(" ");

				const { days, hours, minutes } = parts.reduce(
					(accumulator, part, index) => {
						const value = parseInt(parts[index - 1]);
						if (part === "days") {
							accumulator.days = value;
						} else if (part === "hours") {
							accumulator.hours = value;
						} else if (part === "minutes") {
							accumulator.minutes = value;
						}
						return accumulator;
					},
					{ days: 0, hours: 0, minutes: 0 },
				);

				const totalElapsedDays = days + hours / 24 + minutes / (24 * 60);
				const progress = 100 - (totalElapsedDays / totalTimeSpan) * 100;

				return { progress, days, hours, minutes };
			}
		}
		return { progress: 100, days: 0, hours: 0, minutes: 0 };
	}, [methodologyDetails?.methodologyRoundStatus, reviewEndDate]);

	const isMethodologyStatusRunning = methodologyDetails.methodologyRoundStatus === "RUNNING";
	const timeLeft = `${Math.max(days, 0)}/${totalTimeSpan} days
				${hours && hours > 0 ? `(${hours} hrs)` : ""}
				${minutes && minutes > 0 ? `(${minutes} mins)` : ""}
				left`;

	return (
		<div className="mt-8 space-y-2">
			<p>
				{`${isMethodologyStatusRunning ? "Feedback open" : "Round closed"}`}
				{(!props.hideDetailsIfRoundClosed || isMethodologyStatusRunning) && `,${timeLeft}`}
			</p>
			{(!props.hideDetailsIfRoundClosed || isMethodologyStatusRunning) && <ProgressBar progress={progress} />}
		</div>
	);
};

export default FeedbackTimeline;
